import { render } from "./Faq-Bosa.vue?vue&type=template&id=118de470"
import script from "./Faq-Bosa.vue?vue&type=script&lang=js"
export * from "./Faq-Bosa.vue?vue&type=script&lang=js"

import "./Faq-Bosa.vue?vue&type=style&index=0&id=118de470&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__